// Logout for the BFF session cookie flow.
// Calls POST /api/auth/logout (backend revokes the refresh token and clears the cookie),
// then navigates to the redesigned /logout page, which shows a confirmation and
// redirects to /login (the "Continue with Okta" page) after a short delay.

import { recordSessionEvent } from './sessionAudit';
import { clearToken } from './tokenStorage';
import { clearSession } from './session';
import { AUTH_STORAGE_KEYS } from './keys';
import { apiUrl, appUrl } from '@/shared/config';

let terminalLogoutStarted = false;

/** Handle a server-terminal 401 once across all browser transports. */
export function handleSessionExpired(): void {
  if (terminalLogoutStarted) return;
  terminalLogoutStarted = true;
  void logout();
}

export async function logout(): Promise<void> {
  await recordSessionEvent('logout').catch(() => {});

  clearToken();
  clearSession();

  try {
    localStorage.removeItem(AUTH_STORAGE_KEYS.sessionKey);
  } catch {
    // ignore
  }

  try {
    await fetch(apiUrl('/auth/logout'), {
      method: 'POST',
      credentials: 'include',
    });
  } catch {
    // best-effort; redirect regardless
  }

  window.location.replace(appUrl('/logout'));
}
